import { render, staticRenderFns } from "./AdminSignals.vue?vue&type=template&id=28231abe&scoped=true"
import script from "./AdminSignals.vue?vue&type=script&lang=js"
export * from "./AdminSignals.vue?vue&type=script&lang=js"
import style0 from "./AdminSignals.vue?vue&type=style&index=0&id=28231abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28231abe",
  null
  
)

export default component.exports